import { useChallengePlayer } from '@infl-ts/util-use-challenge-player';
import { Alert, AlertTitle, Button } from '@mui/material';
import * as A from 'fp-ts/Array';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { useTranslation } from 'react-i18next';
import { RejectedCorporateAlertEntry } from '../../codecs';
import CorporateConfirmationAlert from '../../corporate-confirmation-alert';
import StageLayout from '../stage-layout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var getLastTimelineEntry = function getLastTimelineEntry(activity) {
  return pipe(activity, O.fromNullable, O.map(function (activity) {
    return activity.timeline;
  }), O.chain(O.fromNullable), O.map(A.filter(function (entry) {
    return entry.createdAt !== null;
  })), O.chain(A.last));
};

var CorporateApproval = function CorporateApproval(_ref) {
  var stage = _ref.stage,
      activity = _ref.activity,
      prospect = _ref.prospect;

  var _useChallengePlayer = useChallengePlayer(),
      closeChallengePlayer = _useChallengePlayer.closeChallengePlayer;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(StageLayout, {
    stage: stage,
    prospect: prospect,
    actions: /*#__PURE__*/_jsx(Button, {
      sx: {
        mx: 'auto'
      },
      size: "large",
      variant: "contained",
      onClick: closeChallengePlayer,
      children: t('Close challenge')
    }),
    "data-element": "StageLayout",
    "data-component": "CorporateApproval",
    "data-source-file": "index.tsx",
    children: pipe(activity, getLastTimelineEntry, O.chain(O.fromPredicate(RejectedCorporateAlertEntry.is)), O.match(function () {
      return /*#__PURE__*/_jsxs(Alert, {
        sx: {
          mt: 4,
          mx: 3
        },
        severity: "info",
        children: [/*#__PURE__*/_jsx(AlertTitle, {
          sx: {
            fontWeight: 'bold'
          },
          children: t('The team is reviewing your challenge response')
        }), t("We'll send you a notification once we're done!")]
      });
    }, function (lastTimelineEntry) {
      return /*#__PURE__*/_jsx(CorporateConfirmationAlert, {
        status: "ActivityTimelineChallengeRejected",
        admin: lastTimelineEntry.admin,
        feedback: lastTimelineEntry.feedback
      });
    }))
  });
};

export default CorporateApproval;